import React, { useContext, useEffect, useRef, useState } from 'react';

import { toast } from 'react-toastify';
import { AppContext } from '../../../contexts/AppContext';
import useWarehouseOrderRatesService from '../../../app/services/hooks/useWareHouseOrderRateService';
import { WarehouseOrderShowRateDataForm } from '../../../app/models/WareHouseOrderRates';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import WarehouseQuoteRateShowForm from '../../Quotes/subpages/WareHouseQuote/components/forms/WareHouseRatesForms/WareHouseRatesShowForm';
import LazyLoading from '../../../components/LazyLoading';

interface Props {
    rateId: number;
    onSaved?: () => void;
    onCancel: () => void;
    onError?: () => void;
}

const WarehouseOrderRateShow = ({
    rateId,
    onSaved,
    onCancel,
    onError
}: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {showWarehouseOrderRate, fetchingShowWarehouseOrderRate} =
        useWarehouseOrderRatesService();

    const [showRate, setShowRate] = useState<WarehouseOrderShowRateDataForm>({});

    useEffect(() => {
        show();
    }, [rateId]);

    const show = () => {
        showWarehouseOrderRate(rateId, {
                onSuccess: (response: ServiceResponse) => {
                    setShowRate(response.data.rate);

                },

        });
    };

    return (

        <>
                        {!fetchingShowWarehouseOrderRate ? (
                            <>
                                <WarehouseQuoteRateShowForm
                                  rateForm={showRate}

                                />
                            </>
                        ) : (
                            <LazyLoading />
                        )}

        </>
    );
};

export default WarehouseOrderRateShow;
